// extracted by mini-css-extract-plugin
export default {"containerInfo":"Info_containerInfo__vKIZ4","headerInfo":"Info_headerInfo__ehHR8","bodyInfo":"Info_bodyInfo__dcTbz"};